import CircularProgress from '@mui/material/CircularProgress';
import { useEffect } from 'react';

const Loader = () => {
  useEffect(() => {
    // Prevent scrolling when the component mounts
    document.body.classList.add('no-scroll');

    // Re-enable scrolling when the component unmounts
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  return (
    <div className="loader">
      <CircularProgress color="primary" />
    </div>
  );
};

export default Loader;
